<template lang="pug">
	div
		b-alert(:show='alert.error.hideCountDown' fade dismissible variant='danger' @dismissed='alert.error.hideCountDown=0' @dismiss-count-down='countDownChanged($event, "error")')
			p {{ alert.error.message }}

		b-alert.mb-3(:show='alert.success.hideCountDown' fade dismissible variant='success' @dismissed='alert.success.hideCountDown=0' @dismiss-count-down='countDownChanged($event, "success")')
			p {{ alert.success.message }}
</template>

<script>
export default {
	name: "Alerts",
	props: [],
	data:()=>({
		alert: {
			success: {
				hideSecs: 5,
				hideCountDown: 0,
				message: 'Запрос успешно отправлен!'
			},
			error: {
				hideSecs: 5,
				hideCountDown: 0,
				message: 'Во время запроса произошла ошибка!'
			}
		},
	}),
	methods: {
		countDownChanged(hideCountDown, event){
			this.alert[event].hideCountDown = hideCountDown;
		},
		showAlert(message, event) {
			this.alert[event].hideCountDown = this.alert[event].hideSecs;
			this.alert[event].message = message ? message : this.alert[event].message;
		},
	}
}
</script>
